/*
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-03-02 11:50:32
 * @LastEditTime: 2021-06-10 17:24:20
 * @Description:增加二次验证
 */
const PASSCHANGE_REQ_DATA = [
  {
    key: "NotRequired",
    value: 0,
    text: "均不强制修改密码"
  },
  {
    key: "Required",
    value: 1,
    text: "Web登录时强制修改密码"
  },
  {
    key: "RequiredAndDeny",
    value: 2,
    text: "Web和客户端登录时强制修改密码"
  }
];
const PASSCHANGE_REQ = {};
const PASSCHANGE_REQ_TEXT = {};
for (let item of PASSCHANGE_REQ_DATA) {
  PASSCHANGE_REQ[item.key] = item.value;
  PASSCHANGE_REQ_TEXT[item.value] = item.text;
}
export { PASSCHANGE_REQ, PASSCHANGE_REQ_TEXT };
